module.exports = __webpack_public_path__ + "img/python.6dd7bc34.png";